import React, { useEffect, useState } from "react";
import { ListView } from "antd-mobile";
import CommentList from "./CommentList";
import WriteComment from "./WriteComment";
import styles from "./ArticleCommentList.modules.less";
import CommentItem from "./CommentItem";
import { fetchPaging } from "@Services/api";

import { article } from "@Api";
import { Spin } from "antd";

const { fatchArticleGetComment } = article;

interface IState {
  commentNum: any;
  /**
   * 原始数据
   */
  dataSource: any[];
  /**
   * ListView所需数据格式
   */
  ListViewDataSource: any[];
  /**
   * 热门评论
   */
  hotComment: any[];
  paging: string;
}

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1: any, row2: any) => row1 !== row2,
});

const IframeCommentListPage: React.FC = () => {
  const { id, type } = window.article;
  const [remarkData, setRemarkData] = useState<IState>({
    commentNum: "---",
    dataSource: [],
    ListViewDataSource: [],
    hotComment: [],
    paging: "",
  });
  const [showLoading, setShowLoading] = useState(false);

  const getList = async () => {
    setShowLoading(true);
    try {
      const res = await fatchArticleGetComment({ id, type });
      res && articleComment(res);
    } catch (error) {
      setShowLoading(false);
      console.log(error);
    }
  };

  const articleComment = (data: any) => {
    const hotArr: any = [];

    hotArr.push(data.hotComment);

    setRemarkData({
      dataSource: data.data.length === 0 ? [] : data.data,
      ListViewDataSource: data.data.length === 0 ? [] : dataSource.cloneWithRows(data.data),
      commentNum: data.comment_num,
      paging: data.paging,
      hotComment: data.hotComment.length === 0 ? [] : hotArr,
    });
    setShowLoading(false);
  };

  const onEndReached = async () => {
    const { paging, ListViewDataSource, dataSource, hotComment } = remarkData;
    if (paging === "") return;
    const res = await fetchPaging(paging);
    if (res) {
      const list: any[] = dataSource.concat(res.data);
      setRemarkData({
        ListViewDataSource: (ListViewDataSource as any).cloneWithRows(list),
        paging: res.paging,
        hotComment,
        commentNum: res.comment_num,
        dataSource: list,
      });
    }
  };

  const refreshList = () => {
    setRemarkData({
      commentNum: "---",
      dataSource: [],
      ListViewDataSource: [],
      hotComment: [],
      paging: "",
    });
    getList();
  };

  useEffect(() => {
    getList();
  }, [window.article]);

  return (
    <section className={"w-full"}>
      <div className={styles["IframeCommentList"]}>
        <div className={styles["send-comment"]}>
          <h3 className={styles["title"]}>發佈我的評論</h3>
          {remarkData.dataSource.length !== 0 && (
            <span className={styles["current-comment-count"]}>
              當前<b>{remarkData.commentNum}</b>條評論
            </span>
          )}
        </div>
        <WriteComment
          placeholder={
            remarkData.dataSource.length !== 0 ? "看完文章思如泉湧，快來和小夥伴們交流想法吧~" : "快來發佈第一條評論吧"
          }
          id={id}
          type={type}
          response={() => {
            refreshList();
          }}
        />

        {showLoading && (
          <div className={styles["loading-seciton"]}>
            <Spin size='large' />
          </div>
        )}

        {remarkData.hotComment.length !== 0 && (
          <div className={styles["comment-seciton"]}>
            <CommentList commentData={remarkData.hotComment} title='熱門評論' response={() => refreshList()} />
          </div>
        )}

        <section className={styles["CommentList"]}>
          <h3 className={styles["title"]}>最新評論</h3>
          {remarkData.dataSource.length !== 0 && (
            <ListView
              dataSource={remarkData.ListViewDataSource}
              pageSize={20}
              renderRow={(item) => <CommentItem data={item} response={() => refreshList()} />}
              onEndReachedThreshold={100}
              onEndReached={() => onEndReached()}
              scrollEventThrottle={500}
              useBodyScroll={true}
            />
          )}
        </section>
      </div>
    </section>
  );
};
export default IframeCommentListPage;
